import { Component, ElementRef, OnInit, ViewChild , Inject} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReviewDetail } from 'src/core/account/action/account.action';
import { MatDialog } from '@angular/material/dialog';
import { ReviewDetailsComponent } from '../review-details/review-details.component';




@Component({
  selector: 'app-review-popup',
  templateUrl: './review-popup.component.html',
  styleUrls: ['./review-popup.component.css']
})
export class ReviewPopupComponent implements OnInit {
  @ViewChild("fileInput") fileInput: ElementRef;
  rating: any;
  maxRating: number = 5;
  stars: boolean[] = [];
  reviewForm:FormGroup
  productId: any;
  selectedFiles: File[] = [];
  base64Files: string[] = [];
  constructor(public dialogRef: MatDialogRef<ReviewPopupComponent>,private fb:FormBuilder,@Inject(MAT_DIALOG_DATA) public data: any, public http:HttpClient, public dialog: MatDialog

) { 
    this.reviewForm = this.fb.group({
      // rating:['',Validators.required],
      title:['',Validators.required],
      name:['',Validators.required],
      email: ['', [Validators.required, Validators.email]], 
      review:['',Validators.required],
      invoice:['',Validators.required],
      img:['']

      
    })
    var email = localStorage.getItem('user')

    this.reviewForm.get('email').setValue(email)

    console.log("product id", data)
      this.productId = data
  }

  // dialogRef.afterClosed().subscribe(result => {
  //   if (result === 'success') {
  //   }
  // });




  ngOnInit(): void {
    this.setStars(); 

    // this.product.getProductdetail().subscribe(res =>{
    //   console.log("details",res)

    //   this.productDetail.productDetails$.subscribe(detail => {
    //     console.log('product detail--->', detail);})

    // })
   
  }
  selectFile(): void {
    this.fileInput.nativeElement.value = "";
    this.fileInput.nativeElement.click();
  }

  rate(rating: number) {
    this.rating = rating;
    // this.ratingClick.emit(rating);
    this.setStars();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  setStars() {
    this.stars = Array(this.maxRating).fill(false);
    const fullStars = Math.floor(this.rating);
    const hasHalfStar = this.rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      this.stars[i] = true;
    }

    if (hasHalfStar) {
      this.stars[fullStars] = true;
    }
    console.log("starssss",this.stars)
  }

  submit(){
    console.log('----reviewForm',this.reviewForm.value)
    const params: any = {};
    // params.productId = this.details.productId;
    // params.orderProductId = this.details.orderProductId;
    
    

    let values: boolean[] = this.stars;
    let countTrue = values.filter(value => value === true).length;
    params.title = this.reviewForm.value.title;
   
    // params.name = this.reviewForm.value.name;
    // params.image = this.reviewForm.value.img;


    params.productId= this.productId
    params.email = this.reviewForm.value.email;
    params.reviewTitle = this.reviewForm.value.title;
    params.reviews = this.reviewForm.value.review;
    params.rating = countTrue;
    params.image =  this.base64Files

    this.http.post(environment.storeUrl+'orders/add-rating?params',params).subscribe((res:any) => {
      console.log("testing api",res);
      this.reviewPopup(res)
      this.closeDialog()
    });
    console.log("final value rewiwuploadddd", params)
     
      
  
    }


    reviewPopup(response){
      const dialogRef = this.dialog.open(ReviewDetailsComponent, {
        width: "25%", 
        height:'max-content',
        data:response
        
      });
    }

    

    // onFileSelected(event: Event): void {
    //   const input = event.target as HTMLInputElement;
    //   if (input.files) {
    //     for (let i = 0; i < input.files.length; i++) {
    //       this.selectedFiles.push(input.files[i]);
    //     }
    //   }
    //   console.log("multiselect imagessss", this.selectedFiles)
    // }
    onFileSelected(event: Event): void {
      const input = event.target as HTMLInputElement;
      if (input.files) {
        for (let i = 0; i < input.files.length; i++) {
          this.selectedFiles.push(input.files[i]);
          this.convertToBase64(input.files[i]);
        }
      }
      console.log("Selected Files:", this.selectedFiles);
      console.log("Base64 Files:", this.base64Files);
    }
  
    convertToBase64(file: File): void {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result) {
          this.base64Files.push(reader.result as string);
        }
      };
      reader.readAsDataURL(file);
      console.log("valuessssssssssssss", this.base64Files)
    }


    removeFile(index: number): void {
      this.selectedFiles.splice(index, 1);
    }

}
